import React from "react";
import ReactDOM from "react-dom";

import ChatApp from "./ChatApp";

import "./index.css";

/**
 * Accesses data handed into frame via URL
 * gid - required
 * iid - required
 * pid - optional, bot will ask user about which pid to use for the given iid if pid not supplied
 */
// function decodeURL() {
//   if (!window.location.href.split("?")[1]) {
//     console.log("No data passed in to Chat element :(.");
//     return;
//   }
//   var params = window.location.href.split("?")[1].split("&");
//   var data = {};
//   for (var x in params) {
//     data[params[x].split("=")[0]] = decodeURIComponent(params[x].split("=")[1]);
//   }
//   return data;
// }
function decodeURL() {
  if (!window.location.href.split("?")[1]) {
    console.log("No data passed in to Chat element :(.");
    return;
  }
  var params = window.location.href.split("?")[1].split("&");
  var data = {};
  for (var x in params) {
    data[params[x].split("=")[0]] = decodeURIComponent(params[x].split("=")[1]);
  }
  return data;
}

function normalizeParamKey(key) {
  return String(key || "")
    .toLowerCase()
    .replace(/[_\-\s]/g, "");
}

function getParamFromObject(obj, keys) {
  if (!obj) return "";
  var keyMap = {};
  keys.forEach(function (k) {
    keyMap[normalizeParamKey(k)] = true;
  });

  for (var key in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
    if (!keyMap[normalizeParamKey(key)]) continue;
    var value = obj[key];
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      return String(value).trim();
    }
  }

  return "";
}

function getParamFromSearch(search, keys) {
  if (!search) return "";
  var params;
  try {
    params = new URLSearchParams(search);
  } catch (err) {
    return "";
  }

  var all = {};
  params.forEach(function (value, key) {
    all[key] = value;
  });

  return getParamFromObject(all, keys);
}

function getParamFromUrl(urlLike, keys) {
  if (!urlLike || typeof urlLike !== "string") return "";
  try {
    var parsedUrl = new URL(urlLike, window.location.origin);
    return getParamFromSearch(parsedUrl.search, keys);
  } catch (err) {
    var idx = urlLike.indexOf("?");
    if (idx === -1) return "";
    return getParamFromSearch(urlLike.substring(idx), keys);
  }
}

function resolveAccountAndContactId(data) {
  var accountKeys = ["accountId", "accountid", "accountID"];
  var contactKeys = ["contactId", "contactid", "contactID"];

  var accountId =
    getParamFromObject(data, accountKeys) ||
    getParamFromSearch(window.location.search, accountKeys) ||
    getParamFromUrl(data && data.location, accountKeys) ||
    getParamFromUrl(data && data.referrer, accountKeys) ||
    "";

  var contactId =
    getParamFromObject(data, contactKeys) ||
    getParamFromSearch(window.location.search, contactKeys) ||
    getParamFromUrl(data && data.location, contactKeys) ||
    getParamFromUrl(data && data.referrer, contactKeys) ||
    "";

  return {
    accountId: accountId,
    contactId: contactId,
  };
}

var parent_location,
  parent_title,
  gid,
  iid,
  pid,
  mobile,
  parent_referrer,
  defaultOpen,
  position,
  customStyle,
  previewMode,
  serviceview,
  messenger,
  imagedomain,
  messengerId,
  language,
  fallbackMessage,
  businessName,
  chainName,
  contactId,
  propertyName,
  userEmail,
  userName,
  userType,
  accountId;
var data = decodeURL();
var resolvedIds = resolveAccountAndContactId(data || {});

if (data) {
  parent_referrer = data.referrer;
  parent_location = data.location;
  parent_title = data.title;
  gid = data.gid;
  pid = data.pid;
  iid = data.iid;
  mobile = data.mobile;
  defaultOpen = data.open ? true : false;
  previewMode = data.preview ? data.preview : false;
  position = data.position === "left" ? "chat_area_left" : "chat_area";
  customStyle = data.custom ? "custom" : "";
  serviceview = data.serviceview === "true" ? true : false;
  messenger = data.messenger === "true" ? true : false;
  imagedomain =
    data.imagedomain ?? "https://bmbuiassetsprod.blob.core.windows.net";
  messengerId = data.messengerId ?? "";
  language = data.language ?? "en";
  fallbackMessage = data.fallbackMessage ?? "";
  businessName = data.businessName ?? "";
  chainName = data.chainName ?? "";
  contactId = resolvedIds.contactId;
  propertyName = data.propertyName ?? "";
  userEmail = data.userEmail ?? "";
  userName = data.userName ?? "";
  userType = data.userType ?? "";
  accountId = resolvedIds.accountId;
}

if (!gid || !iid) {
  // gid = "12848620-d54c-4be7-bebc-ac44014c964c";
  // pid = "e655dab2-987b-4683-ad9b-599814b414b6";
  gid = "73574010-2f33-4b41-8b8a-09d18b025a56";
  //gid = "f49d1df2-f9b3-416e-a366-adf7ef6e7c63";
  //pid = "e655dab2-987b-4683-ad9b-599814b414b6";
  //iid = 'f206b9ac-ad8a-4b41-9c00-c885d86ab7fe';
  // iid = "290542d7-e9bc-4609-a437-e859a7d12d83";
  // iid = '306574d2-7370-4a74-a0fc-b8ca2b850d8b';
  mobile = true;
  iid = "2ddcb06d-8a79-46dc-ab38-367080ca3f78";
  //iid='1b429f53-0d99-4f62-90d5-f92ab96e8d9d';
  //iid = "b4974ef9-3ad4-4205-ab07-f4711f118c54";
  defaultOpen = false;
  position = "chat_area";
  customStyle = "";
  serviceview = false;
}
// Make sure frame is open when the bot is being interacted with (see chatplugin.js)
window.addEventListener("click", (evt) => {
  if (
    evt !== undefined &&
    evt.target !== undefined &&
    evt.target.className !== undefined &&
    evt.target.className === "internal-link"
  ) {
    let payload = {
      url: evt.target.href,
    };
    window.postMessage("openInternalLink:" + JSON.stringify(payload));
    evt.preventDefault();
  } else {
    window.postMessage("chatbotwindowOpen");
  }
  // console.log(100, window.hj)
  // if (window.hj) {
  //   window.hj('trigger', 'chatbot_page_loaded', {
  //     gid: gid,
  //     iid: iid,
  //   });
  // }
});

console.log(accountId, contactId);

ReactDOM.render(
  <ChatApp
    parent_location={parent_location}
    parent_title={parent_title}
    parent_referrer={parent_referrer}
    gid={gid}
    iid={iid}
    pid={pid}
    mobile={mobile}
    defaultOpen={defaultOpen}
    position={position}
    customStyle={customStyle}
    previewMode={previewMode}
    serviceview={serviceview}
    messenger={messenger}
    imagedomain={imagedomain}
    messengerId={messengerId}
    language={language}
    fallbackMessage={fallbackMessage}
    accountId={accountId}
    contactId={contactId}
    propertyName={propertyName}
    userEmail={userEmail}
    userName={userName}
    userType={userType}
    businessName={businessName}
    chainName={chainName}
    AHData={
      accountId != "" ||
      contactId != "" ||
      propertyName != "" ||
      userEmail != "" ||
      userName != "" ||
      userType != "" ||
      businessName != "" ||
      chainName != ""
        ? true
        : false
    }
  />,
  document.getElementById("root"),
);
